import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { useStyles } from '../../../common/hooks/useStyles';
import { splitViewSelector } from '../../../common/store/selectors/splitView.selector';
import { getCloseId } from '../htmlElements/htmlElementsIdGetter';
import { CloseIcon } from '../../../common/components/closeIcon/closeIcon';
import { isEmpty } from '../../../common/utils/utils';
import { anchorDataSelector } from '../../../common/store/selectors/anchorData.selector';
import { anchorOptionsSelector } from '../../../common/store/selectors/anchorOptions.selector';
import { COMMON_ICON_TYPES } from '../../../common/components/icon/iconMapper';
import { getCloseButtonStyleObject } from './closeButton.style';

export const CloseButton: FunctionComponent = () => {
  const playerSize = useSelector(playerDataSelector.playerSize);
  const splitViewRatio = useSelector(splitViewSelector.splitViewRatio);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const anchorStatus = useSelector(anchorDataSelector.anchorStatus);
  const canClose = useSelector(anchorOptionsSelector.canClose);

  const isAnchored = anchorStatus === 'active';
  const showCloseIcon = isAnchored && canClose && !isEmpty(splitViewRatio);

  const styles = useStyles(getCloseButtonStyleObject, [playerSize, showCloseIcon]);
  const { closeIconStyle } = styles;

  return (
    <CloseIcon
      icon={COMMON_ICON_TYPES.CLOSE_FILL}
      style={closeIconStyle}
      id={getCloseId(playerUniqueId)}
      addClickableWrapper={false}
    />
  );
};
